import { FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE } from "../Constants";

const init = {
    email: {},
    forget_data: {}
};

const ForgotPasswordReducer = (state = init, action) => {
    switch (action.type) {
        case FORGOT_PASSWORD:
            return { ...state, loading: true };
        case FORGOT_PASSWORD_SUCCESS:
            return { ...state, loading: false, forget_data: action.payload };
        case FORGOT_PASSWORD_FAILURE:
            return { ...state, loading: false, forget_data: action.payload };
        default:
            return state;
    }
};

export default ForgotPasswordReducer;